<template>
  <MenuComponent
    custom_title="Suppliers.MySuppliers">
    <template v-slot:navbar="{ mini }">
      <SuppliersNavBar
        ref="navBar"
        :counts="statistic || {}"
        :filter.sync="filterPage"
        :loading="loading"
        :mini="mini"
        :suppliers="suppliers"
        @changeFilter="$_scrollTo(null, 0,0)"
        @filterByTypes="filterByTypes"/>
    </template>
    <template v-slot:filter>
      <SuppliersToolbar
        ref="suppliersToolbar"
        :all-headers="headers"
        :filters="filterPage"
        :loading="loading"
        @applyFilters="applyFilters"
        @applySearch="applySearch">
        <template
          slot="append">
          <CheckEDRPOU
            class="mr-2"/>
          <DownloadSuppliersToExcel
            :count="statistic[filterPage.count_type]"
            :disabled="!count"
            :filter="filterModel"/>
        </template>
      </SuppliersToolbar>
    </template>
    <template v-slot:items>
      <EmptyBlock
        v-if="!loading && (!suppliers || !suppliers.length )"
        :text="countFilter ? $t('Tenders.NoResultsForSearch') : $t('Suppliers.NoData')"/>
      <div
        v-if="suppliers.length"
        class="content pt-8">
        <SupplierCard
          v-for="(item, n) in suppliers"
          :key="item.egrpou + '-' + item.supplierOrganizationId"
          ref="supplier_card"
          :item="item"
          :last="n == (suppliers.length - 1)"
          :loading="loading"
          :opened="openCard[n]"
          @close="saveOpenState(n, false)"
          @open="saveOpenState(n, true)"/>
      </div>
    </template>
    <template v-slot:loader>
      <InfinityUpdater
        ref="infinity_updater"
        :action="infinityLoad"
        :active="can_load"
        class="mt-3"
        :loading="loading "
        :pixels_when_update="200"/>
    </template>
  </MenuComponent>
</template>

<script>
import MenuComponent from 'pages/templates/MenuComponent.vue'
import SupplierCard from 'components/supplies/SupplierCard.vue'
import EmptyBlock from 'components/common/elements/EmptyBlock.vue'
import InfinityUpdater from 'components/extends/InfinityUpdater.vue'
import SuppliersNavBar from 'components/supplies/SuppliersNavBar.vue'
import SuppliersToolbar from 'components/supplies/SuppliersToolbar.vue'
import CheckEDRPOU from 'components/tenders/dialogs/CheckEDRPOU.vue'
import DownloadSuppliersToExcel from 'components/tenders/dialogs/DownloadSuppliersToExcel.vue'

import { mapGetters } from 'vuex'
import { doomMixin, storageMixin, modalMixin } from 'mixins'

export default {
  name: 'suppliers',
  mixins: [ doomMixin, storageMixin, modalMixin],
  data() {
    return {
      loading: false,
      count: 0,
      countFilter: 0,
      suppliers: [],
      filter: {
        allowedVerificationStatuses: null,
        verificationDecision: null,
        verificationDecisionDateRange: null,
        verificationStatusDateRange: null,
      },
      filterPage: {
        all: true,
        count_type: 'total',
        name: 'Suppliers.AllSuppliers',
        type: 'All',
        search: '',
      },
      headers: [
        {text: this.$t('Suppliers.CheckStatus'), value: 'allowedVerificationStatuses', setFilter: true, type: 'allowedVerificationStatuses'},
        {text: this.$t('Suppliers.VerificationSolution'), value: 'verificationDecision', setFilter: true, type: 'verificationDecision'},
        {text: this.$t('Suppliers.DecisionDate'), value: 'verificationDecisionDateRange', setFilter: true, type: 'verificationDecisionDateRange'},
        {text: this.$t('Suppliers.DateOfValidityOfTheCheck'), value: 'verificationStatusDateRange', setFilter: true, type: 'verificationStatusDateRange'}
      ],
      openCard: [],
      startProp: {
        countLoadItem: null,
        scrollTopId: null,
      }
    }
  },
  async created() {
    this.loading = true
    const prevValues = this.$_getPropFromLocalStorage('suppliers.openCards', [])

    this.startProp.countLoadItem = this.$_getPropFromLocalStorage('suppliers.countLoadItem', 0)
    this.startProp.scrollTopId = this.$_getPropFromLocalStorage('suppliers.scrollTopId', 0)
    prevValues.forEach((index) => {
      this.$set(this.openCard, index, true)
    })

    // this.$store.dispatch('getSuppliersShortStatistic', {filter: this.filterModel, refresh: false})
    this.$store.dispatch('getCrmVerificationFillingInfo')

    await this.$_getFiltersFromDBStorage()
      .then(async (storage_filters) => {
        if (storage_filters) {
          this.applyFilters(storage_filters.filters, null, storage_filters.search)
        }
      })
      .finally(() => {
        this.loading = false
        this.loadData()
      })
  },
  computed: {
    ...mapGetters({
      statistic: 'getSuppliersShortStatistic',
      changeOrganisation: 'changeOrganisation',
    }),
    filterModel() {
      const deltaTake = this.$route.meta.from ? this.startProp?.countLoadItem || 0 : 0
      return {
        fastFilters: this.filterPage.type.toUpperCase(),
        phrase: this.filterPage.search,
        take: this.per_page + deltaTake,
        skip: this.count,
        allowedVerificationStatuses: this.filter.allowedVerificationStatuses,
        verificationDecision: this.filter.verificationDecision,
        verificationDecisionDateRange: this.filter.verificationDecisionDateRange,
        verificationStatusDateRange: this.filter.verificationStatusDateRange,
      }
    },
    can_load() {
      return !this.loading && this.statistic && this.statistic[this.filterPage?.count_type] > this.count
    },
    per_page() {
      return Math.floor((document.documentElement.clientHeight || 0) / 200 ) || 4
    },
  },
  methods: {
    setOldScrollPosition() {
      if (!this.$route.meta.from.name || !this.startProp?.scrollTopId) { return }
      setTimeout(() => {
        if (document.getElementById(this.startProp?.scrollTopId)) {
          document.getElementById(this.startProp?.scrollTopId).scrollIntoView({
            behavior: 'smooth',
            block: 'center',
          })
          this.startProp = null
        }
        this.$_savePropToLocalStorage('suppliers.scrollTopId', null)
      }, 50)
    },
    saveOpenState(index, state) {
      this.$set(this.openCard, index, state)
      this.$nextTick(() => {
        const keys = this.openCard?.length ? Object.entries(this.openCard).filter(i => i[1]).map(i => parseInt(i[0])) : ''
        this.$_savePropToLocalStorage('suppliers.openCards', keys)
      })
    },
    readStatistic(filter, refresh) {
      this.$store.dispatch('getSuppliersShortStatistic', {filter: filter || this.filterModel, refresh})
    },
    async loadData(push) {
      if ( this.loading  ) { return }
      this.loading = true
      if ( !push ) {
        this.count = 0
        this.suppliers = []
      }
      const filter = this.$_.cloneDeep(this.filterModel)
      await this.$store.dispatch('getTenderSuppliersInfo', filter)
        .then(res => {
          if (res) {
            this.count += res.length
            this.suppliers?.push(...res)
            this.applySearch(this.filterPage.search)
          }
        })
        .finally(() => {
          this.loading = false
          if (!push) {
            if ( this.startProp ) {
              this.setOldScrollPosition()
            }
          }
          this.readStatistic(filter)
        })
    },
    infinityLoad() {
      this.loadData(true)
    },
    filterByTypes(item) {
      this.filterPage = { ...item, search: this.filterPage.search}
      // this.filterPage = item
      this.loadData()
    },
    applyFilters(filters, mode, search) {
      this.countFilter = 0
      const getFilterValue = (key, filters, type = 'array') => {
        let result

        if (!key || !filters) { return result }

        const filterObject = filters.find(i => i.type === key)
        if (!filterObject) { return null }

        if (type === 'dateRange' ) {
          result = { from: filterObject.search[0], to: filterObject.search[1] }
        } else if (type === 'string' ) {
          result = filterObject.search
        } else {
          result = filterObject.search
        }
        if (result) {
          this.countFilter += 1
        }
        return result
      }
      this.filterPage.search = search
      this.filter.allowedVerificationStatuses = getFilterValue('allowedVerificationStatuses', filters),
      this.filter.verificationDecision = getFilterValue('verificationDecision', filters, 'string'),
      this.filter.verificationDecisionDateRange = getFilterValue('verificationDecisionDateRange', filters, 'dateRange'),
      this.filter.verificationStatusDateRange = getFilterValue('verificationStatusDateRange', filters, 'dateRange'),
      this.loadData()
    },
    applySearch(search) {
      this.filterPage.search = search
      this.loadData()
    },
  },
  watch: {
    changeOrganisation( val ) {
      if ( !val ) {
        //this.readStatistic(true)
        this.loadData()
      } else {
        this.suppliers = []
      }
    },
  },
  beforeRouteLeave(to, from, next) {
    if (to.params && to.params.id) {
      this.$_savePropToLocalStorage('suppliers.scrollTopId', to.params.id)
    }
    this.$_savePropToLocalStorage('suppliers.countLoadItem', this.count)
    next()
  },
  components: {
    EmptyBlock,
    CheckEDRPOU,
    SupplierCard,
    MenuComponent,
    InfinityUpdater,
    SuppliersNavBar,
    SuppliersToolbar,
    DownloadSuppliersToExcel
  }
}
</script>
